// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2WwiV","approved":"Status_approved__1vvCV","rejected":"Status_rejected__3BLYd","expired":"Status_expired__cQfdB","label":"Status_label__3NNeu"};